/* fp-v2-drag-scroll.js
   ───────────────────────────────────────────────────────────────────────────
   Drag-to-scroll pour les sliders horizontaux natifs (overflow-x: auto).

   POURQUOI : sur Mac le trackpad envoie du scroll horizontal nativement, mais
   avec une souris (Windows) la molette ne fait que du vertical. Sans drag, un
   slider en scroll natif est donc littéralement inatteignable sur Windows.

   USAGE : poser `data-fpv2-drag-scroll` sur l'élément scrollable (celui qui
   porte overflow-x: auto), et charger ce script. L'init est automatique.
   Le style (cursor grab, is-dragging → snap off) est dans section-fp-v2-tokens.css.

   Le clic qui suit un drag est avalé en phase capture : sans ça, relâcher après
   avoir dragué ouvrirait l'overlay vidéo ou suivrait le lien produit.
*/
(function () {
  var THRESHOLD = 5; // px avant de considérer que c'est un drag et non un clic

  function init(el) {
    if (el.dataset.fpv2DragScrollReady === 'true') return;
    el.dataset.fpv2DragScrollReady = 'true';

    var down = false, moved = false, startX = 0, startScroll = 0, pointerId = null;

    function swallowClick(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      el.removeEventListener('click', swallowClick, true);
    }

    el.addEventListener('pointerdown', function (ev) {
      if (ev.button !== 0) return;
      // Si le drag précédent n'a jamais été suivi d'un clic, on nettoie ici :
      // évite d'avaler le premier clic légitime d'après.
      el.removeEventListener('click', swallowClick, true);
      down = true;
      moved = false;
      startX = ev.clientX;
      startScroll = el.scrollLeft;
      pointerId = ev.pointerId;
      el.classList.add('is-grabbing');
    });

    el.addEventListener('pointermove', function (ev) {
      if (!down) return;
      var dx = ev.clientX - startX;
      if (!moved && Math.abs(dx) > THRESHOLD) {
        moved = true;
        el.classList.add('is-dragging');
        try { el.setPointerCapture(pointerId); } catch (e) {}
      }
      if (moved) {
        el.scrollLeft = startScroll - dx;
        ev.preventDefault();
      }
    });

    function endDrag() {
      if (!down) return;
      down = false;
      el.classList.remove('is-grabbing', 'is-dragging');
      try { el.releasePointerCapture(pointerId); } catch (e) {}
      // Le listener se retire lui-même au 1er clic avalé (ou au pointerdown
      // suivant s'il n'y a pas de clic) — pas de setTimeout, pas de pari sur
      // l'ordre pointerup/click.
      if (moved) el.addEventListener('click', swallowClick, true);
      moved = false;
    }

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);

    // Coupe le drag natif des <img> / <a>, qui vole le geste au 1er pixel.
    el.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
  }

  function initAll(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-fpv2-drag-scroll]');
    Array.prototype.forEach.call(els, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor : re-init après re-render d'une section.
  document.addEventListener('shopify:section:load', function (ev) { initAll(ev.target); });
})();
